import React, { Component } from 'react';
import './MapUI.scss';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import context from './../../context';
import DrawControl from '../../layerManager/DrawControl';
import { geometryUtil } from '../../util/geometryUtil';
// @inject('baseMapStore')
// @observer
export default class MapUI extends Component {
    map = null;
    mapDiv = null;
    constructor(props) {
        super(props)
        this.state = {
            location:"",
        }
    }
    componentDidMount() {
        // reaction(() => this.props.baseMapStore.currentBaseMap, (e) => {
        //     console.log(e);
        // })
        // console.log(this.mapDiv);
        this.map = L.map(this.mapDiv, { zoomControl: false }).setView([33.226422, 110.508369], 5);
        this.map.on("moveend", this._onMapMoveend);
        this.map.on("zoomend", this._onMapZoomend);
        this.map.on('click', this._onClick);
        this.setBaseMap("OSM");

        // var myIcon = L.divIcon({className: 'my-div-icon'});
        var myIcon = L.icon({
            iconUrl: 'map/source/images/marker-icon.png',
            iconSize: [38, 95],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
        });
        
        L.marker([36.2550971456653,120.035344362259], {icon: myIcon}).addTo(this.map);
        const coords =  [
        [
            [120.015850, 36.218790], 
            [120.001431, 36.220594], 
            [119.994564, 36.228764], 
            [119.995766, 36.239150], 
            [119.994907, 36.248599], 
            [119.994049, 36.255625], 
            [119.993877, 36.266525], 
            [119.992676, 36.281853], 
            [120.003233, 36.291403], 
            [120.053358, 36.296734], 
            [120.059710, 36.294101], 
            [120.075417, 36.284412], 
            [120.077648, 36.277218], 
            [120.079107, 36.270781], 
            [120.081682, 36.261372], 
            [120.082712, 36.249947], 
            [120.081253, 36.232227], 
            [120.068893, 36.228488], 
            [120.057907, 36.222255], 
            [120.043831, 36.220870], 
            [120.015850, 36.218790]  
        ]]
        console.log();

        let polygon = L.polygon(geometryUtil.coordinates2leaflet(coords),  {
                        "size": "2",
                        "color": "rgba(252,219,87,1)",
                        "fillColor": "rgba(252,219,87,0.4)"});
        polygon.addTo(this.map);



        // 初始化 FeatureGroup 来存储绘制的图形
        var drawnItems = new L.FeatureGroup();
        this.map.addLayer(drawnItems);
        var drawControl = new DrawControl({drawnItems});
        // 将绘制控件添加到地图上
        this.map.addControl(drawControl);

        // 监听绘制完成事件
        this.map.on(L.Draw.Event.CREATED, function (event) {
            var layer = event.layer;
            var layerType = event.layerType;
            drawnItems.addLayer(layer);
            // console.log(layerType);
            // 处理绘制完成后的逻辑
            if (layerType === "polygon") {
                console.log("绘制了一个多边形:", layer.toGeoJSON());
            } else if (layerType==="rectangle") {
                console.log("绘制了一个矩形:", layer.toGeoJSON());
            } else if (layerType === "polyline") {
                console.log("绘制了一个线段:", layer.toGeoJSON());
            } else if (layerType === "marker") {
                console.log("绘制了一个标记:", layer.toGeoJSON());
            } else if (layerType === "circle") {
                console.log("绘制了一个圆:", layer.toGeoJSON());
            }
        });

        // 监听编辑和删除事件
        this.map.on(L.Draw.Event.EDITED, function (event) {
            console.log("图形被编辑:", event.layers);
        });

        this.map.on(L.Draw.Event.DELETED, function (event) {
            console.log("图形被删除:", event.layers);
        });

        context.map = this.map;
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {

    }
    setBaseMap = (key) => {
        let baseMapUrl = context.appConfig.basemap&&context.appConfig.basemap.find(f => f.key === key).url;
        let myFilter = [
            'blur:0px',
            'brightness:95%',
            'contrast:130%',
            'grayscale:20%',
            'hue:290deg',
            'opacity:100%',
            'invert:100%',
            'saturate:300%',
            'sepia:10%',
        ];
        // L.tileLayer.colorFilter(baseMapUrl, {
        //     attribution: '',
        //     maxZoom: 13,
        //     minZoom: 3,
        //     zoom: 3,
        //     filter: myFilter,
        // }).addTo(this.map);

        L.tileLayer(baseMapUrl, {
            attribution: '',
            maxZoom: 13,
            minZoom: 3,
            // subdomains: "1234",
            zoom: 3,
        }).addTo(this.map);
    }
    _onMapMoveend = () => {
    }
    _onMapZoomend = (e) => {
    }
    _onClick = (e) => {
        console.log(e);
        const {latlng} = e;
        L.popup().setLatLng(latlng).setContent('<p>Hello world!<br />This is a nice popup.</p>').openOn(this.map);
    }
    addLayer = () => {

    }
    render() {
        return (
            <div className="map_UI" ref={ref => this.mapDiv = ref}>
            </div>
        )
    }
}
